import { render, staticRenderFns } from "./active-smartwatch-settings.page.vue?vue&type=template&id=1d99761e&scoped=true&"
import script from "./active-smartwatch-settings.page.vue?vue&type=script&lang=js&"
export * from "./active-smartwatch-settings.page.vue?vue&type=script&lang=js&"
import style0 from "./active-smartwatch-settings.page.vue?vue&type=style&index=0&id=1d99761e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99761e",
  null
  
)

export default component.exports